import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../static/styles/LearnWin.module.css';
import gamezAcad1 from '../static/img/LearnWin/gamezAcad_1.avif';
import gamezAcad2 from '../static/img/LearnWin/gamezAcad_2.avif';
import gamezAcad3 from '../static/img/LearnWin/gamezAcad_3.avif';

const LearnWin = () => {
  const { t } = useTranslation();
  const learnWinImages = [gamezAcad1, gamezAcad2, gamezAcad3];

  useEffect(() => {
    document.title = `${t('learn_n_win')} | Jazz Esl`
  }, [t])

  return (
    <div className={styles.container}>
      <h1 className={styles.heading}>{t('learn_n_win')}</h1>
      <p className={styles.subheading}>{t('test_mettle')}</p>
      <div className={styles.grid}>
        {learnWinImages.map((image, index) => (
          <div
            key={index}
            className={styles.card}
            onClick={() => window.open('https://gamezacademy.pk/', '_blank')}
            style={{ cursor: 'pointer', backgroundImage: `url(${image})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}
          >
          </div>
        ))}
      </div>
    </div>
  );
};

export default LearnWin;
